import { render } from "./DmHeader.vue?vue&type=template&id=7a29ddd4&scoped=true"
import script from "./DmHeader.vue?vue&type=script&lang=js"
export * from "./DmHeader.vue?vue&type=script&lang=js"

import "./DmHeader.vue?vue&type=style&index=0&id=7a29ddd4&scoped=true&lang=css"

import exportComponent from "/builds/digitalmasters/team-wombat/alenus-bottle-o-ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a29ddd4"]])

export default __exports__